module.exports = __webpack_public_path__ + "img/privacy-policy-header.e3323be.png";